module.exports = __webpack_public_path__ + "static/media/ELTENEMO_FINAL-Bleu.53d5ba44.png";